import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'

export default class QmlComponent extends React.Component {
    static cardName = `Common/PatientIdentification.qml`;
    
    constructor() {
        super()
        this._ismounted = false
        this.state = {
            qml : null
        }
    }

    componentDidMount() {
        this._ismounted = true
        //console.log("!!!<<<<<<CDM>>>>>>>!!! ", this.cardName)
        

        //console.log('about to this.loadQML')
// Soure code from QML file starts here 
setTimeout( () => { 
this.loadQML(String.raw`
import Semantic.Html 1.0
import QmlWeb 1.0

Segment {
    id: subPatientIdentification
    property bool inverted: false
    property string size: ''
    property bool hideAfter: false
    property bool compact: false

    function clear(){
        rmdPatient.patientId = ''
        rmdPatient.encounterId = ''
        rmdPatient.hn = ''
        rmdPatient.full_name = ''
        rmdPatient.gender_name = ''
        rmdPatient.birthdate = ''
        rmdPatient.full_age = ''
        rmdPatient.citizen_no = ''
        rmdPatient.age = ''
        rmdPatient.profile_image = undefined
    }
    function reload(patientId){
        subPatientIdentification.clear()
        subPatientIdentification.displayNone = false
        rmdPatient.patientId = patientId
        rmdPatient.fetch()
    }
    function reloadFromEncounter(encounterId){
        subPatientIdentification.clear()
        subPatientIdentification.displayNone = false
        rmdPatient.encounterId = encounterId
        rmdPatient.fetch()
    }
    className: {
        var classList = []
        if (subPatientIdentification.size) {
            classList.push(subPatientIdentification.size)
        }
        if (subPatientIdentification.inverted) {
            classList.push('inverted')
        }
        return classList.join(' ')
    }
    onHideAfterChanged: {
        if (subPatientIdentification.hideAfter) {
            subPatientIdentification.displayNone = true
        }
    }
    Form {
        className: subPatientIdentification.className
        Fields {
            className: 'inline small-padding'
            Field {
                Button {
                    id: btnPatientImage
                    className: 'icon circular mini'
                    icon: 'user'
                }
            }
            Field {
                label: 'HN'
            }
            Field {
                style: 'flex-basis: 100px; flex-grow: 1;'
                TextBox {
                    id: txtPatientHN
                    inputStyle: 'text-align: center;'
                    className: 'fluid'
                    readOnly: true
                }
            }
            Field {
                label: _('ชื่อผู้ป่วย')
            }
            Field {
                style: 'flex-basis: 300px; flex-grow: 2;'
                TextBox {
                    id: txtPatientFullName
                    className: 'fluid'
                    readOnly: true
                }
            }
            Field {
                label: _('เพศ')
            }
            Field {
                style: 'flex-basis: 75px; flex-grow: 1;'
                displayNone: subPatientIdentification.compact
                TextBox {
                    id: txtPatientGender
                    inputStyle: 'text-align: center;'
                    className: 'fluid'
                    readOnly: true
                }
            }
            Field {
                style: 'flex-basis: 40px; flex-grow: 1;'
                displayNone: !subPatientIdentification.compact
                TextBox {
                    id: txtPatientGenderShort
                    inputStyle: 'text-align: center;'
                    className: 'fluid'
                    readOnly: true
                    text: txtPatientGender.text[0] || ''
                }
            }
            Field {
                label: subPatientIdentification.compact ? _('เกิด') : _('วันเกิด')
            }
            Field {
                style: 'flex-basis: 110px; flex-grow: 1;'
                TextBox {
                    id: txtPatientBirthdate
                    inputStyle: 'text-align: center;'
                    className: 'fluid'
                    readOnly: true
                }
            }
            Field {
                label: _('อายุ')
            }
            Field {
                style: 'flex-basis: 150px; flex-grow: 1;'
                displayNone: subPatientIdentification.compact
                TextBox {
                    id: txtPatientAge
                    inputStyle: 'text-align: center;'
                    className: 'fluid'
                    readOnly: true
                }
            }
            Field {
                style: 'flex-basis: 50px; flex-grow: 1;'
                displayNone: !subPatientIdentification.compact
                TextBox {
                    id: txtPatientAgeShort
                    inputStyle: 'text-align: center;'
                    className: 'fluid'
                    readOnly: true
                }
            }
            Field {
                label: _('เลขบัตร')
                displayNone: subPatientIdentification.compact
            }
            Field {
                style: 'flex-basis: 150px; flex-grow: 1;'
                displayNone: subPatientIdentification.compact
                TextBox {
                    id: txtPatientIden
                    inputStyle: 'text-align: center;'
                    className: 'fluid'
                    readOnly: true
                }
            }
        }
    }
    TooltipDialog {
        id: tldPatientImage
        target: btnPatientImage
        activeEvent: 'hover'
        Image {
            id: imgPatient
            className: 'small rounded'
            source: _.get(rmdPatient, 'profile_image.image') || '../../static/images/person.png'
        }
    }
    RestModel {
        id: rmdPatient

        property var patientId
        property var encounterId
        url: {
            if (patientId) {
                return '/apis/REG/patient/{0}/'.format(patientId)
            } else if (encounterId) {
                return '/apis/REG/patient/encounter/{0}/'.format(encounterId)
            } else {
                return ''
            }
        }

        property alias hn: txtPatientHN.text
        property alias full_name: txtPatientFullName.text
        property alias gender_name: txtPatientGender.text
        property alias birthdate: txtPatientBirthdate.text
        property alias age: txtPatientAgeShort.text
        property alias full_age: txtPatientAge.text
        property alias citizen_no: txtPatientIden.text
        property var profile_image
    }
}

        `)
}, 0)

    }

    componentWillUnmount() {
        this._ismounted = false
        //console.log(" ***** componentWillUnmount ", this.cardName)
        document.onkeypress = null;
        document.onkeyup = null;

        // this.engine.stop()
        if(this.qml){
            this.qml.destroy()
            this.removeChildProperties(this.qml)
        }
        
        // this.qml = null
        // this.engine = null
        if(this.props.onUnmount){
            this.props.onUnmount()
         }
        // window.QmlWeb.engine.dom = null
        // window.QmlWeb.engine.domTarget = null
        // window.QmlWeb.engine.rootObject = null
        // window.QmlWeb.engine.completedSignals = []
        // window.QmlWeb.engine = {}
        //console.log(" ***** componentWillUnmount Finish ", this.cardName)
    }

    loadQML = (src, parentComponent = null, file = undefined) => {
        this.loadQMLTree(window.QmlWeb.parseQML(src, file), parentComponent, file);
        
        // let component = this.loadQMLTree(window.QmlWeb.parseQML(src, file), parentComponent, file);
        // this.qml = this.engine.rootObject
        // return component
    }

    loadQMLTree = (tree, parentComponent = null, file = undefined) => {

        // Part 1
        let QMLComponent; 
        let component;

        setTimeout( () => { 

            if (!this._ismounted){
                //console.log(" Shutdown Part 1", this.cardName)
                return;
            }
            this.engine = window.QmlWeb.engine;
        
            if (!this.engine) {
                this.engine = new window.QmlWeb.QMLEngine(ReactDOM.findDOMNode(this));
                // window.addEventListener("resize", () => this.engine.updateGeometry());
            } else {
                this.engine.cleanEngine(ReactDOM.findDOMNode(this))
            }

            this.engine.$basePathA = document.createElement('a')
            this.engine.$basePathA.href = this.extractBasePath(`/static/qml/Common/PatientIdentification.qml`)
            this.engine.$basePath = this.engine.$basePathA.href
            //console.log(" CDM this.engine.$basePathA.href: ", this.engine.$basePathA.href)

            window.QmlWeb.engine = this.engine;

            // Create and initialize objects
            QMLComponent = window.QmlWeb.getConstructor("QtQml", "2.0", "Component");
            component = new QMLComponent({
                object: tree,
                parent: parentComponent
            });
            //console.log("Part 1", this.cardName)
        },0)

        setTimeout(() => {
            if (!this._ismounted){
                //console.log(" Shutdown Part 2", this.cardName)
                return;
            }
            
            this.engine.loadImports(tree.$imports, undefined, component.importContextId);
            component.$basePath = this.engine.$basePath;
            component.$imports = tree.$imports; // for later use
            component.$file = file; // just for debugging
            //console.log("Part 2", this.cardName)
        }, 0);
    

        // Part 3,4,5
        setTimeout(() => {
            if (!this._ismounted){
                //console.log(" Shutdown Part 3", this.cardName)
                return;
            }
            this.engine.rootObject = component.$createObject(parentComponent);
            
            if (this.engine.rootObject.dom) {
                this.engine.domTarget.appendChild(this.engine.rootObject.dom);
            }
     
            this.qml = this.engine.rootObject
            this.setUpSignals()
            this.setUpProperties()
            //console.log("3. setUpSignals(), setUpProperties() Done", this.cardName)
 
            this.engine.$initializePropertyBindings();
            this.engine.start();

            this.engine.updateGeometry();
            this.qml = this.engine.rootObject

            this.setState({qml: this.qml})
            //console.log("4. finish loadQMLTree", this.cardName)

            
            this.engine.firstCallCompleted = false;
            this.engine.callCompletedSignals();
            this.engine.firstCallCompleted = true;
            //console.log("5. CallCompletedSignal", this.cardName)

            if (this.props.completedQMLLoad) {
                //console.log("Callback completedQMLLoad !!")
                setTimeout( () => {
                    this.props.completedQMLLoad()
                })
            }
        }, 0);
    }
    
    deCapitalizeFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    hasSignalName(signalName) {
        return (
            typeof this.qml[signalName] === 'function' 
            && typeof this.qml[signalName].connect === 'function'
        )
    }

    setUpSignals() {
        _.forOwn(this.props, (value, key) => {
            let signalName = this.deCapitalizeFirstLetter(key.replace('on', ''))
            let startsWithOn = key.startsWith('on')
            let typeFunction = typeof value === 'function'
            if (!startsWithOn || !typeFunction) {
                return
            }
            if (!this.hasSignalName(signalName)) {
                console.warn('Cannot find a signal name: ' + signalName)
                return
            }
            this.qml[signalName].disconnect()
            this.qml[signalName].connect(this.qml, value)
        })
    }

    setUpProperties() {
        _.forOwn(this.props, (value, key) => {
            let signalName = this.deCapitalizeFirstLetter(key.replace('on', ''))
            let propertyExists = typeof this.qml.$properties[key] !== 'undefined'
            if (this.hasSignalName(signalName)) {
                return
            }
            if (!propertyExists) {
                const createProperty = window.QmlWeb.createProperty;
                createProperty("variant", this.qml, key, value);
                //console.warn('Cannot find a property name: ' + key)
                // return
            }
            this.qml[key] = value
        })
    }

    extractBasePath(file) {
        const basePath = file.split(/[/\\\\]/)
        basePath[basePath.length - 1] = ''
        return basePath.join('/')
    }

    extractFileName(file) {
        return file.split(/[/\\\\]/).pop()
    }

    removeChildProperties(child) {
        const signals = this.engine.completedSignals
        if (signals) {
            signals.splice(signals.indexOf(child.Component.completed), 1)
        }
        if(child.children) {
            for (let i = 0; i < child.children.length; i++) {
                this.removeChildProperties(child.children[i])
            }
        }
        child.$signals = null
    }

    render() {
        if (this.state.qml) {
            this.setUpSignals()
            this.setUpProperties()
        }
        return React.createElement('div')
    }
}